<div>
  <div class="header-terms">Terms and Conditions</div>
  <br>
 <div class="col-12">
  <textarea class="tex-area" [(ngModel)]="myTextarea"></textarea>
  </div>
  <br>
  <div class="col-12">
  <mat-checkbox [checked]="false" class="ml-0" (change)="toggleEditable($event)"></mat-checkbox>
 Click here to accept the terms and conditions 
 <br>
 <br>
  <button id="save"  (click) = "getDetails()"   type="button" mat-raised-button color="primary" disabled>Ok</button>
  <div>
  </div>	